import constant from '../../constant';
import request from '../../../utils/request';
import { GET_CONTENT } from '../../../urls'
import { showTip } from '../../../utils'

const getArticle = (params = {}) => {

  return async (dispatch) => {
    try {
      const sDocId = params.sDocId
      if (sDocId) {  
        if (window._configs.articleContent && window._configs.articleContent.docId) {
          dispatch(getArticleSuccess(window._configs.articleContent))
          return window._configs.articleContent
        }
        const { ch, dataSrc } = params
  
        const res = await request.get(GET_CONTENT, {
          docId: sDocId,
          // url: decodeURIComponent(url),
          ch,
          dataSrc,
          apn: "wifi"
        })

        if (res.code === 0) {
          dispatch(getArticleSuccess(res.data))
        } else {
          showTip('文章跑丢了')
        }
      } else {
        showTip('缺少必要参数 sDocId')
      }
  
    } catch (error) {
      console.log('getArticle error',error)
      showTip(error.msg || '服务异常，请稍后再试')
    } 
  }
}


const getArticleSuccess = (article) => {
  return {
    type: constant.ARTICLE.GET,
    article
  }
}


export default {
  getArticleSuccess,
  getArticle,
}